<template lang="pug">
modal#onboarding-recipient-modal(
  :cancelAction='backAction'
  :close-button-label='$t("button.cancel")'
  :process-button-label='processButtonLabel'
  :show-cancel-button='showCancelButton'
  :title='$t("modal.onboardingRecipient.title")'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12
    template(v-if='step === 1')
      p {{ $t('modal.onboardingRecipient.messageStep1') }}
      .text-center
        img.img-fluid(src='/img/ilustrations/onboarding-novo-destinatario.gif')
    template(v-if='step === 2')
      p {{ $t('modal.onboardingRecipient.messageStep2') }}
      .text-center
        img.img-fluid(
          src='/img/ilustrations/onboarding-select-option-destinatario.gif'
        )
    template(v-if='step === 3')
      p {{ $t('modal.onboardingRecipient.messageStep3') }}
      .text-center
        img.img-fluid(
          src='/img/ilustrations/onboarding-use-stepbar-destinatario.gif'
        )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'OnboardingRecipientModal',
  components: {
    Modal,
  },
  data() {
    return {
      step: 1,
      finalStep: 3,
    };
  },
  computed: {
    processButtonLabel() {
      return this.step === this.finalStep ? 'Ok' : this.$t('button.next');
    },
    showCancelButton() {
      return this.step > 1;
    },
  },
  methods: {
    process() {
      if (this.step === this.finalStep) {
        this.$refs.modal.close();
        this.$emit('finished');
        return;
      }
      this.step += 1;
    },
    backAction() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
  },
};
</script>
